import { createServerFn } from "@tanstack/solid-start";
import { z } from "zod";
import { withSentrySpan } from "~/lib/sentry-span";
import { authFunctionMiddleware } from "~/server/middleware/auth";

export const GetBalanceSheetInputSchema = z.object({
  businessId: z.string().trim().min(1),
  asOf: z.string().trim().min(1).optional(),
});

export const getBalanceSheet = createServerFn({ method: "GET" })
  .middleware([authFunctionMiddleware])
  .validator((i: unknown) => GetBalanceSheetInputSchema.parse(i))
  .handler(async ({ context, data }) => {
    return withSentrySpan("reports.balanceSheet", async () => {
      const { getBalanceSheetForUser } = await import("./balance-sheet.server");
      return getBalanceSheetForUser(context.user.id, data.businessId, {
        asOf: data.asOf,
      });
    });
  });
